<template>
  <!-- 培训课堂 -->
  <div class="warp_room">
    <div class="swiper_warp">
      <div v-if="listData&&listData.length < 6" class="line_one_warp">
        <div
          class="swiper_item"
          :class="active == item.lxId ? 'active' : ''"
          v-for="item in listData"
          :key="item.lxId"
          @click="hangleSwiper(item.lxId)"
        >
          <div class="item_img" :class="active == item.lxId ? 'activeTwo' : ''">
            <img :src="item.lxIcon || '/static/images/icon_zw.png'" alt />
          </div>
          <div
            class="item_text"
          >{{item.lxName && item.lxName.length > 10 ? item.lxName + '...' : item.lxName}}</div>
        </div>
      </div>
      <div v-else class="item_center">
        <div
          class="item_many"
          :class="active == item.lxId ? 'activeMany' : ''"
          v-for="item in listData"
          :key="item.lxId"
          @click="hangleSwiper(item.lxId)"
        >
          <div class="many_img">
            <img :src="item.lxIcon || '/static/images/icon_zw.png'" alt />
          </div>
          <div
            class="many_text"
          >{{item.lxName && item.lxName.length > 10 ? item.lxName + '...' : item.lxName}}</div>
        </div>
        <div class="item_none"></div>
        <div class="item_none"></div>
        <div class="item_none"></div>
      </div>
    </div>
    <div class="room_item" v-show="list">
      <div class="item_center">
        <div class="item_room">
          <div class="item_title">{{titleName}}</div>
          <div class="item_name" v-show="videoList && videoList.length > 0">
            <div class="name_left">未完成的课程</div>
            <div class="name_right" @click="hangleDow" v-if="token && !!this.materialUrl">点我下载电子版材料></div>
          </div>
          <div class="item_sub_item">
            <div
              class="item_sub"
              v-for="(item,index) in videoList"
              :key="index"
              @click="hangleVideo(item.kcId)"
            >
              <div class="center_vider">
                <img v-if="item.kcPic" :src="item.kcPic" alt />
                <img v-else src="/static/images/videoFm.png" alt />
                <div class="item_abs">{{item.timeCourse}}</div>
                <div class="item_icon" v-if="item.pxTime&&item.pxTime > 0">
                  <img src="/static/images/icon_zjxx.png" />
                </div>
              </div>
              <div class="center_text">
                <div class="text_left">{{item.kcMc}}</div>
                <div class="text_right" v-if="item.pxTime">
                  已完成培训
                  <span style="color: #FC7059;">{{s_to_hs(item.pxTime)}}</span>
                  {{item.pxTime >= 60 ? '分钟':'秒'}}
                </div>
                <div class="text_right" v-else>未学习{{activeLxid}}</div>
              </div>
            </div>
            <div class="item_none"></div>
            <div class="item_none"></div>
          </div>
        </div>
      </div>

      <div class="item_process" v-if="token">
        <div class="process_item">
          <div class="item_show">
            <div class="show_left">
              <!-- 企业名称和用户角色 -->
              <div class="show_imput" v-if="priseList&&priseList.length > 0">
                <el-select
                  v-model="busValue"
                  filterable
                  @change="hangleChange"
                  placeholder="请选择要搜索的企业名称"
                  class="select_qy"
                >
                  <template slot="prefix">
                    <span
                      class="select_qy_prefix"
                    >【{{busValue ? sfQyfr == 1 ? "法定代表人":sfQyfr == 0 ?"经办人":'用户角色':'用户角色'}}】</span>
                  </template>
                  <el-option
                    v-for="item in priseList"
                    :key="item.qyId"
                    :label="item.qyMc"
                    :value="item.qyId"
                  >
                    <!-- <span style="float: left">{{ item.qyMc }}</span>
                    <span style="float: right">{{ item.sfQyfr == 0 ? "法人":"经办人" }}</span>-->
                  </el-option>
                </el-select>
              </div>
              <!-- 培训进程 -->
              <div class="name_icon">
                <div class="title">
                  <img src="/static/images/icon_jc.png" alt />
                  <div class="name_name">{{titleName}}培训进程</div>
                </div>
                <div v-if="busValue">
                  <div class="content" v-if="wsqy == 1 && qyPxzt == 0">
                    <div class="name_title" v-if="qyShzt == 0">请耐心等待您上传的材料通过审核</div>
                    <div class="name_title" v-else-if="qyShzt != 1">关联外省失败，请重新上传资料</div>
                    <template v-else-if="qyShzt == 1">
                      <div class="name_title" v-if="!userPxTime">您当前还未开始参加培训，快去参加培训吧~</div>
                      <div
                        class="name_title"
                        v-else
                      >{{titleName}}培训需要完成{{totalPxTime}}分钟的课时培训，您当前已参加培训{{s_to_hs(userPxTime) || 0}}{{userPxTime >= 60 ? '分钟':'秒'}}</div>
                    </template>
                  </div>
                  <div class="content" v-else-if="qyPxzt < 3">
                    <div class="name_title" v-if="!userPxTime">您当前还未开始参加培训，快去参加培训吧~</div>
                    <div
                      class="name_title"
                      v-else
                    >{{titleName}}培训需要完成{{totalPxTime}}分钟的课时培训，您当前已参加培训{{s_to_hs(userPxTime) || 0}}{{userPxTime >= 60 ? '分钟':'秒'}}</div>
                  </div>
                </div>
                <div v-else>
                  <div class="content">
                    <div class="name_title" v-if="priseList&&priseList.length > 0">请先选择企业</div>
                    <div class="name_title" v-else>请先关联企业</div>
                  </div>
                </div>
              </div>
              <!-- 可以获取报告 -->
              <div
                class="name_report"
                v-if="busValue && (qyPxzt == 3 || (qyPxzt == 4 && lxCjbg == 1) || qyPxzt == 5 || qyPxzt == 7)"
              >
                <div class="report_left">
                  <template v-if="qyPxzt == 3 && (lxKsgn == 1 || lxCjbg==1)">
                    <div class="left_icon"></div>
                    <div
                      class="left_bg"
                      v-if="(totalCompted <= userPxTime) && lxKsgn == 1 && examination != 5"
                    >已通过培训，点击参加考试</div>
                    <div
                      class="left_bg"
                      v-if="(totalCompted <= userPxTime) && lxKsgn == 1 && examination == 5"
                    >未通过考试，可参加补考</div>
                    <div
                      class="left_bg"
                      v-if="(totalCompted <= userPxTime) && lxKsgn == 0 && lxCjbg==1"
                    >点击申请信用报告。></div>
                  </template>
                  <template v-if="qyPxzt == 4 || qyPxzt == 5 || qyPxzt == 7">
                    <div class="left_icon"></div>
                    <div
                      class="left_bg"
                      @click="hangleTraining(6)"
                      style="cursor:pointer"
                    >已通过考试，点我查看培训证明~</div>
                  </template>
                  <template v-if="qyPxzt == 4 && qyShzt == 1">
                    <div class="left_icon" style="margin-left: 20px;"></div>
                    <div class="left_bg">已通过考试，信用报告制作中，请耐心等待~</div>
                  </template>
                  <template
                    v-if="(qyPxzt==4 && lxCjbg == 0)|| (qyPxzt==3 && lxKsgn == 0 && lxCjbg == 0)"
                  >
                    <div class="left_icon"></div>
                    <div class="left_bg">恭喜您，已完成培训~</div>
                  </template>
                </div>
                <div class="report_right" v-if="qyPxzt == 5">
                  <div class="left_icon"></div>
                  <div
                    class="left_bg"
                    @click="hangleCredit(7)"
                    style="cursor:pointer"
                  >已获取信用报告，点我查看详情~</div>
                </div>
              </div>
              <!-- 历史记录 -->
              <div v-if="isHistoricalRecord > 0" class="history" @click="hangleSee">查看历史培训记录</div>
            </div>
            <div class="show_right">
              <template v-if="priseList&&priseList.length > 0 && busValue">
                <template v-if="wsqy == 1 && qyPxzt == 0">
                  <div class="item_button" v-if="qyShzt == 0">等待审核</div>
                  <div class="item_button" v-else-if="qyShzt != 1" @click="hangleWsqyModify">重新上传资料</div>
                  <template v-else-if="qyShzt == 1">
                    <div class="item_button">未完成培训无法参加考试</div>
                  </template>
                </template>
                <template v-else-if="qyPxzt < 3">
                  <div class="item_button">未完成培训无法参加考试</div>
                </template>
                <template v-if="qyPxzt == 3">
                  <div
                    class="item_button"
                    v-if="(totalCompted <= userPxTime) && lxKsgn == 1 && examination != 5"
                    @click="hangleExam"
                  >已完成培训，点我参加考试</div>
                  <div
                    class="item_button"
                    v-if="(totalCompted <= userPxTime) && lxKsgn == 1 && examination == 5"
                    @click="hangleExam"
                  >点我参加补考</div>
                  <div
                    class="item_button"
                    v-if="(totalCompted <= userPxTime) && lxKsgn == 0 && lxCjbg == 1"
                    @click="hangleReport"
                  >点我申请征信报告</div>
                </template>
                <template v-if="qyPxzt == 4 && lxCjbg==1">
                  <div class="item_button" v-if="qyShzt == 0" @click="hangleReport">点我申请征信报告</div>
                  <div class="item_button" v-else-if="qyShzt == 1">信用报告制作中，请耐心等待</div>
                  <div class="item_button" v-else>等待征信报告审核</div>
                </template>
                <template v-if="qyPxzt == 7">
                  <div
                    class="item_button"
                    v-if="qyShzt == -1 || qyShzt == 2 || qyShzt == 3"
                    @click="hangleModify"
                  >点我修改申请资料</div>
                  <div class="item_button" v-else>等待征信报告审核</div>
                </template>
                <template
                  v-if="qyPxzt == 5 || (qyPxzt==4 && lxCjbg == 0)|| (qyPxzt==3 && lxKsgn == 0 && lxCjbg == 0)"
                >
                  <div class="item_button" @click="dialogVisibleThree = true">再次培训</div>
                </template>

                <!-- <template v-if="qyShzt == -1 || qyShzt ==2 || qyShzt == 3"> -->
                <template v-if="qyShyy && qyShyy.length > 0">
                  <div class="item_popo" v-for="(item,index) in qyShyy" :key="index">
                    <el-popover width="200" trigger="hover">
                      <div>{{index+1}},{{item}}</div>
                      <el-button slot="reference">查看修改意见</el-button>
                    </el-popover>
                  </div>
                </template>
              </template>
              <template v-else-if="priseList&&priseList.length > 0">
                <div class="item_button">您还未选择企业</div>
              </template>
              <template v-else>
                <div class="item_button" @click="gotoRelationQy">去关联企业</div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!--         <div class="item_process">
           <div class="process_item">
              <div class="process_sub">
                 <div class="sub_left">
                   <div class="left">
      <img src="/static/images/icon_jc.png" alt="">-->
      <!-- <div>{{titleName}}培训进程</div> -->
      <!-- <div>行政处罚培训进程</div>
      </div>-->
      <!--      <div class="process_name" v-show="token">
                       <el-select v-model="busValue" filterable @change="hangleChange" placeholder="请选择要搜索的企业名称" style="width: 242px;">
                          <el-option
                            v-for="item in priseList"
                            :key="item.qyId"
                            :label="item.qyMc"
                            :value="item.qyId">
                          </el-option>
                        </el-select>
      </div>-->

      <!-- </div> -->
      <!-- <div class="sub_right"> -->
      <!-- <template v-if="qyPxzt <= 1 && qyShzt == 0">
                     <div class="text">已通过考试，点我查看培训证明~</div>
                     <div class="right_text">等待审核</div>
                   </template>
                   <template v-if="qyShzt == -1 && qyZfzt == 1">
                     <div class="text">已通过考试，点我查看培训证明~</div>
                     <div class="right_text" @click="hangleModify">点我修改申请资料</div>
      </template>-->
      <!-- <template v-if="qyPxzt < 3">
                     <div class="text" v-if="userPxTime == 0">您当前还未开始参加培训，快去参加培训吧~</div>
                     <div class="text" v-else>行政处罚培训需要完成{{totalPxTime}}分钟的课时培训，您当前已参加培训{{userPxTime || 0}}分钟…</div>
                     <div class="right_text">未完成培训无法参加考试</div>
                   </template>
                   <template v-if="qyPxzt == 3">
                     <div class="text" v-if="(totalCompted <= userPxTime) && lxKsgn == 1" style="cursor: pointer;">已通过培训，点击参加考试 ></div>
                     <div class="text" v-if="(totalCompted <= userPxTime) && lxKsgn == 0" style="cursor: pointer;">已通过考试，点我查看培训证明 ></div>
                     <div class="right_text" v-if="(totalCompted <= userPxTime) && lxKsgn == 1" @click="hangleExam">去考试</div>
                     <div class="right_text" v-if="(totalCompted <= userPxTime) && lxKsgn == 0" @click="hangleExam">点我申请征信报告</div>
                   </template>
                   <template v-if="qyPxzt == 3 && lxKsgn == 0">
                       <div class="text" style="cursor: pointer;">点我申请征信报告 ~</div>
                      <div class="right_text" v-if="qyShzt == 0" @click="hangleReport">等待审核</div>
                      <div class="right_text" v-else-if="qyShzt == -1" @click="hangleModify">点我修改申请资料</div>
                      <div class="right_text" v-else-if="qyShzt == 2" @click="hangleModify">点我补全申请资料</div>
                      <div class="right_text" v-else-if="qyShzt == 3" @click="hangleModify">点我补全申请资料</div>
                      <div class="right_text" v-else-if="qyShzt == 1">信用报告制作中，请耐心等待</div>
                      <div class="right_text" v-else @click="hangleReport">点我申请征信报告</div>
                    </template>
                  <template v-if="qyPxzt == 4 && lxCjbg == 1">
                      <div class="text" style="cursor: pointer;" @click="hangleTraining(6)">已通过考试，点我查看培训证明 ~</div>
                     <div class="right_text" v-if="qyShzt == 0" @click="hangleReport">等待审核</div>
                     <div class="right_text" v-else-if="qyShzt == -1" @click="hangleModify">点我修改申请资料</div>
                     <div class="right_text" v-else-if="qyShzt == 2" @click="hangleModify">点我补全申请资料</div>
                     <div class="right_text" v-else-if="qyShzt == 3" @click="hangleModify">点我补全申请资料</div>
                     <div class="right_text" v-else-if="qyShzt == 1">信用报告制作中，请耐心等待</div>
                     <div class="right_text" v-else @click="hangleReport">点我申请征信报告</div>
                   </template>

                   <template v-if="qyPxzt == 5">
                     <div style="flex: 1;">
                      <div class="text" style="cursor: pointer;" @click="hangleTraining(6)">已通过考试，点我查看培训证明 ~</div>
                      <div class="text" style="cursor: pointer;" @click="hangleCredit(7)">已获取信用报告，点我查看详情 ~</div>
                     </div>
                     <div class="right_text" @click="dialogVisibleThree = true">再次培训</div>
      </template>-->
      <!-- </div> -->

      <!-- <div class="sub_buttom" v-show="token">
                   <div style="flex:1;"></div>
                   <div class="buttom_right" v-if="qyPxzt == 4" @click="hangleSee">查看历史培训记录 ></div>
                   <div class="buttom_right"  v-if="qyPxzt == 4 && (qyShzt == -1 || qyShzt == 2)">
                     <div  v-for="(item,index) in qyShyy">
                       <el-popover
                          width="200"
                          trigger="hover">
                          <div>{{index+1}},{{item}}</div>
                          <el-button slot="reference">查看修改意见</el-button>
                        </el-popover>
                     </div>
                   </div>
      </div>-->
      <!--   </div>
           </div>
      </div>-->
    </div>

    <!-- 已完成 -->
    <div class="room_item" v-show="list&&completed && completed.length > 0">
      <div class="item_center">
        <div class="item_room">
          <div class="item_name" style="padding-top: 60px;">
            <div class="name_left">已完成的课程</div>
          </div>
          <div class="item_sub_item">
            <div
              class="item_sub"
              v-for="(item,index) in completed"
              :key="index"
              @click="hangleVideo(item.kcId)"
            >
              <div class="center_vider">
                <img v-if="item.kcPic" :src="item.kcPic" alt />
                <img v-else src="/static/images/videoFm.png" alt />
                <div class="item_abs">{{item.timeCourse}}</div>
              </div>
              <div class="center_text">
                <div class="text_left">{{item.kcMc}}</div>
                <div class="text_right" style="color: #FC7059;">已完成</div>
              </div>
            </div>
            <div class="item_none"></div>
            <div class="item_none"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 查看历史培训记录  -->
    <el-dialog title="培训记录" :visible.sync="dialogVisible" width="580px">
      <div class="record_warp">
        <div class="warp" v-for="item in history" :key="item.qyId">
          <div class="warp_top">
            <div class="warp_icon">{{item.qyOne}}</div>
            <div class="warp_name">{{item.qyMc}}</div>
            <div class="warp_title">{{item.lxName}}</div>
          </div>
          <div class="exam_time">
            <div class="time">考试通过时间：{{item.tgrq}}</div>
            <div
              class="prove"
              style="cursor: pointer;"
              @click="hangleTraining(6,item.qyId)"
            >查看培训证明 ></div>
          </div>

          <div class="exam_time">
            <div class="time">报告出具时间：{{item.scrq}}</div>
            <div class="prove" style="cursor: pointer;" @click="hangleCredit(7,item.qyId)">查看信用报告></div>
          </div>
        </div>
      </div>

      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentList.current"
        :page-sizes="[3, 5, 10]"
        :page-size="currentList.pageLimit"
        layout="total, sizes, prev, pager, next"
        :total="currentList.total"
      ></el-pagination>
    </el-dialog>
    <!-- 绑定企业的弹框 -->
    <el-dialog
      title="选择培训的企业"
      :visible.sync="dialogVisibleTwo"
      width="480px"
      :before-close="hangleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <p
          style="font-size: 16px; padding-left: 20px;padding-bottom: 50px;"
          v-if="flag == 2"
        >您好，请先选择您要培训的类型</p>
        <p style="font-size: 16px; padding-left: 20px;padding-bottom: 50px;" v-else>
          您好，请先关联您要进行培训的
          <span style="color: red;">浙江省</span>企业：
        </p>
        <el-form-item label="企业名称" prop="priseName" v-if="flag != 2">
          <el-input
            v-model="ruleForm.priseName"
            style="width: 240px;"
            placeholder="请输入相关企业"
            :maxlength="25"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="选择类型" prop="lxId" v-if="flag != 0">
          <el-select
            :popper-append-to-body="false"
            v-model="ruleForm.lxId"
            placeholder="请选择类型"
            filterable
            clearable
            style="width: 240px;"
            @change="changeLx"
          >
            <el-option
              v-for="item in listData"
              :label="item.lxName"
              :value="item.lxId"
              :key="item.lxId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            style="width: 220px;margin: 10px;"
            type="primary"
            @click="submitForm('ruleForm')"
          >确定</el-button>
        </el-form-item>
        <div class="prise_center">
          <div
            class="prise_left"
            style="cursor: pointer;"
            v-if="flag != 2"
            @click="hangleWrong"
          >关联非浙江省企业></div>
          <div class="prise_left" style="cursor: pointer;" v-else @click="flag = 0">关联浙江省企业></div>
          <!-- <div class="prise_left">个人参加培训></div> -->
        </div>
      </el-form>
    </el-dialog>

    <!-- 再次培训 -->
    <el-dialog title="提示" :visible.sync="dialogVisibleThree" width="400px">
      <span>确认再次培训？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleThree = false">取 消</el-button>
        <el-button type="primary" @click="hangleRetraining">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 确认支付弹窗 -->
    <!-- <el-dialog title="提示" :visible.sync="payDialog" width="400px">
      <span>需要先缴费，要去缴费吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payDialog = false">取 消</el-button>
        <el-button type="primary" @click="hanglePayment">确 定</el-button>
      </span>
    </el-dialog>-->

    <smrz ref="smrz"></smrz>
  </div>
</template>

<script>
import indexHeader from "@/components/index/index_header";
import swiper from "@/components/index/index_swiper";
import Bus from "@/common/js/bus.js";
import { cookie } from "@/common/js/cookies.js";
import smrz from "@/components/common/shrz";
export default {
  props:['activeLxid'],
  data() {
    return {
      dialogVisible: false, //历史记录弹框
      dialogVisibleTwo: false, //新增企业
      dialogVisibleThree: false, //再次培训
      qyMc: null, //企业名称
      kcId: null, //课程id
      active: 0,
      typeList: {}, //课程类型
      titleName: null, //课程名称
      listData: [], //切换的数据类型
      list: null, //判断是否有数据
      totalPxTime: null, //课程培训总时长
      userPxTime: 0, //用户已培训时长
      businessData: {}, //获取当前企业状态
      materialUrl: null, //zip文件
      qyZfzt: null, //支付状态
      currentList: {
        current: 1, //当前页
        pageLimit: 3, //条数
        total: 1, //总数
      },
      history: [], //历史记录
      videoList: [], //视频数据  未完成
      completed: [], //视频数据  已完成
      priseList: [], //名下的企业 长度
      busValue: "", //下拉框选中的企业
      totalCompted: null, //用来判断观看时长

      qyShyy: [], //申请意见

      again: 0, //是否重新培训 0，否 1，是
      pxrId: null, //培训人id
      lxKsgn: null, //考试按钮   0，不显示  1，显示
      lxCjbg: null, //报告  0，不显示 1，显示
      qyPxzt: null, //培训状态  3，去考试
      qyShzt: null, //审核状态

      flag: 0, //来判断触发 0点视频触发，1是浙江省内企业，2是省外企业
      ruleForm: {
        priseName: null, //企业名字
        lxId: null, //类型id
      },
      rules: {
        priseName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        lxId: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
      },
      uniscid: null, //企业统一信用码
      sfQyfr: null, //当前培训人身份 0 法人  1经办人 -1未选公司
      isHistoricalRecord: 0, //大于0显示培训记录
      isSet: false, //是否主动调取setuserQy  true是  false不是
      wsqy: null, //是否外省企业1是其他不是
      examination: null, //是否为补考  5为补考
      payDialog: false, //确认缴费的弹窗

      isAutoProcess: false, //是否开启自动流程跳转

      sfnbg: null, //关联外省企业时类型下面需不需要拿报告
    };
  },
  computed: {
    token() {
      return cookie.get("xyxf_token_qt");
    },
  },
  created() {

    // 自动跳转流程
    // let { sign } = this.$route.query;
    // if (sign == 1) {
    //   let NEXT_DO_OBJ = JSON.parse(localStorage.getItem("NEXT_DO_OBJ"));
    //   this.active = NEXT_DO_OBJ.lxId;
    //   this.kcId = NEXT_DO_OBJ.kcId;
    //   this.busValue = NEXT_DO_OBJ.qyId;
    //   this.isAutoProcess = true;
    //   // 赋值后删除
    //   localStorage.removeItem("NEXT_DO_OBJ");
    // }
  },
  mounted() {
    // this.kcId = this.$store.state.kcId;
    this.getDataList();
    // if (this.token) {
    //   this.getUserQy();
    // }

    if(this.activeLxid){
      this.active = this.activeLxid;
    }
  },
  beforeDestroy() {
    this.$store.state.kcId = null;
  },
  methods: {
    changeLx(val) {
      let lxList = this.listData;
      let currentLxArr = lxList.filter((item) => item.lxId == val);
      this.sfnbg = currentLxArr[0].lxCjbg;
    },
    // 转换时间（小数点格式）
    s_to_hs(s) {
      //计算分钟
      //算法：将秒数除以60，然后下舍入，既得到分钟数
      var result;
      if (s >= 60) {
        var h;
        h = Math.floor(s / 60);
        //计算秒
        //算法：取得秒%60的余数，既得到秒数
        s = s % 60;
        //将变量转换为字符串
        h += "";
        s += "";
        //如果只有一位数，前面增加一个0
        // h = h.length == 1 ? "0" + h : h;
        // s = s.length == 1 ? "0" + s : s;
        result = h + "." + s;
      } else {
        result = s;
      }

      return result;
    },
    //去关联企业
    gotoRelationQy(type) {
      if (type == "open") {
        this.isAutoProcess = true; //开启自动流程
      }
      this.flag = 0;
      this.clickTarget = "video";
      this.ruleForm.priseName = "";
      this.dialogVisibleTwo = true;
    },
    // 点击再次培训 从头开始
    hangleRetraining() {
      this.again = 1;
      this.ruleForm.priseName = this.qyMc;
      this.getAdd();
    },
    // 查看培训报告
    hangleCredit(type, qyId) {
      let _self = this;
      let qyid = null;
      if (qyid) {
        qyid = qyId;
      } else {
        qyid = _self.busValue;
      }
      let ajax = _self.$http.create();
      ajax({
        method: "post",
        url: SOWINURL + "report/getQyfj",
        data: {
          qyId: qyid,
          fjType: type,
        },
        headers: {
          token: _self.token,
        },
      })
        .then(function (json) {
          let resData = json.data.data;
          // if(typeof resData == 'string'){
          _self.download(resData);
          // }else{
          //    _self.payDialog = true;
          // }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 查看培训证明
    hangleTraining(type, qyId) {
      let _self = this;
      let qyid = null;
      if (qyId) {
        qyid = qyId;
      } else {
        qyid = _self.busValue;
      }
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: false,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ajax({
        method: "post",
        url: SOWINURL + "report/getQyfj",
        data: {
          qyId: qyid,
          fjType: type,
        },
        headers: {
          token: _self.token,
        },
      })
        .then(function (json) {
          _self.download(json.data.data);
          loading.close();
        })
        .catch(function (error) {
          loading.close();
          console.log(error);
        });
    },
    // 历史记录查询
    hangleRecord() {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: false,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ajax({
        method: "post",
        url: SOWINURL + "index/getQyPxHistory",
        data: {
          pxrId: _self.pxrId,
          lxId: _self.active,
          cuurPage: _self.currentList.current,
          pageLimit: _self.currentList.pageLimit,
        },
        headers: {
          token: _self.token,
        },
      })
        .then(function (json) {
          loading.close();
          if (json.data.result == 1) {
            _self.history = json.data.data.list; //历史记录
            _self.history.forEach((item) => {
              item.qyOne = item.qyMc.charAt(0); //截取第一个字
            });
            _self.currentList.total = json.data.data.allNum;
          }
        })
        .catch(function (error) {
          loading.close();
          console.log(error);
        });
    },
    // 查看
    download(data) {
      if (!data) {
        return;
      }
      let url = data;
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "");
      link.setAttribute("target", "_blank");

      document.body.appendChild(link);
      link.click();
    },
    // 清除表单
    hangleClose() {
      this.$refs["ruleForm"].resetFields();
      this.dialogVisibleTwo = false;
    },
    // 关联非浙江企业
    hangleWrong() {
      // this.flag = 2;
      this.dialogVisibleTwo = false;
      let routerUrl = this.$router.resolve({
        path: "/qyrz",
        query: {
          lxCjbg: this.sfnbg,
          qyActive: 1,
          pxlx: this.ruleForm.lxId,
        },
      });
      window.open(routerUrl.href, "_blank");
    },
    // 点击去培训来判断
    hangleRepair() {
      console.log()
      this.ruleForm.priseName = ""; //每次点击都空
      // this.ruleForm.lxId = ""; //每次点击都空
      this.dialogVisible = true;
    },
    // 绑定企业
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.flag == 0 || this.flag == 1) {
            // this.active = this.ruleForm.lxId;
            this.getEnterprise();
          } else {
            this.dialogVisible = false;
            let routerUrl = this.$router.resolve({
              path: "/qyrz",
              query: {
                lxCjbg: this.sfnbg,
                qyActive: 1,
                pxlx: this.ruleForm.lxId,
              },
            });
            window.open(routerUrl.href, "_blank");
          }

          // this.$refs.btnClick.hangleVideo(_self.btnKcid);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //作用于来判断 点击下一步是什么功能
    btnTrigger() {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = _self.$loading({
        lock: false,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.5)",
      });
      ajax({
        method: "post",
        url: SOWINURL + "XxKh/getVideoDetail",
        data: {
          kcId: _self.kcId,
          lxId: _self.active,
          qyId: _self.busValue,
          // kcId: 242
        },
      })
        .then(function (json) {
          loading.close();
          if (json.data.result == 1) {
            // 去看视频
            let routerUrl = _self.$router.resolve({
              path: "/courseDetail",
              query: {
                lxId: _self.active,
                kcId: _self.kcId,
                qyId: _self.busValue,
              },
            });
            window.open(routerUrl.href, "_blank");
          } else if (json.data.result == 400) {
            _self.isAutoProcess = false;
            // 点击视频没有关联企业开启自动流程把当前数据存起来
            let data = {
              qyId: _self.busValue,
              lxId: _self.active,
              kcId: _self.kcId,
            };
            localStorage.setItem("NEXT_DO_OBJ", JSON.stringify(data));
            if (json.data.enterprise == 0) {
              //2，名下是否有企业
              _self.gotoRelationQy("open");
              // _self.ruleForm.priseName = "";
              // _self.dialogVisibleTwo = true;
            } else if (json.data.data.autonym == 0) {
              //1,实名
              _self.smrzClick();
            } else if (json.data.data.pay == 0) {
              // 3，是否支付
              _self.hanglePayment();
            } else if (json.data.data.authorization == 0) {
              // 4，是否授权
              _self.$router.push({
                path: "/yzf",
                query: {
                  qyId: _self.busValue,
                  lxId: _self.active,
                  kcId: _self.kcId,
                },
              });
            } else {
            }
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          loading.close();
        });
    },
    // 外省关联审核被拒修改材料
    hangleWsqyModify() {
      let routerUrl = this.$router.resolve({
        path: "/qyrz",
        query: {
          qyId: this.busValue,
          edit: 1,
          lxCjbg: this.lxCjbg,
          qyActive: 1,
          isApplyFor: 1, //区分是申请报告还是关联外省企业
          pxlx: this.active,
        },
      });
      window.open(routerUrl.href, "_blank");
    },
    // 申请报告修改材料
    hangleModify() {
      let routerUrl = this.$router.resolve({
        path: "/qyrz",
        query: {
          qyId: this.busValue,
          edit: 1,
          lxCjbg: this.lxCjbg,
          qyActive: 0,
          isApplyFor: 1, //区分是申请报告还是关联外省企业
          pxlx: this.active,
        },
      });
      window.open(routerUrl.href, "_blank");
    },
    // 点击去申请报告 进入上传资料页面
    hangleReport() {
      this.$router.push({
        path: "/qyrz",
        query: {
          qyId: this.busValue,
          lxCjbg: this.lxCjbg,
          qyActive: 0,
          isApplyFor: 1, //区分是申请报告还是关联外省企业
          pxlx: this.active,
        },
      });
    },
    // 实名认证
    smrzClick() {
      this.$refs["smrz"].sign = 1;
      this.$refs["smrz"].kcId = this.kcId;
      this.$refs["smrz"].drawer = true;
    },
    // 点击去考试
    hangleExam() {
      let routerUrl = this.$router.resolve({
        path: "/exam",
        query: {
          lxId: this.active,
        },
      });
      window.open(routerUrl.href, "_blank");
    },

    // 企业添加
    getAdd() {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = _self.$loading({
        lock: false,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.5)",
      });
      let formdata1 = new FormData();
      formdata1.append("enterpriseName", _self.ruleForm.priseName);
      formdata1.append("lxId", _self.active);
      formdata1.append("uniscid", _self.uniscid);

      ajax({
        method: "post",
        url: SOWINURL + "index/putEnterprise",
        data: formdata1,
      })
        .then(function (json) {
          loading.close();
          if (json.data.result == 200) {
            let messageStr =
              _self.again == 1 ? "重置成功，您可以再次培训了" : "关联企业成功";
            _self.$message({
              showClose: true,
              message: messageStr,
              type: "success",
            });
            // if (_self.again == 1) {
            //   _self.getEnterprise();
            // }else{
            _self.dialogVisibleTwo = false;
            _self.dialogVisibleThree = false;
            // }
            // _self.getUserQy();
            // _self.btnTrigger();
            _self.getMore();
          } else {
            _self.$message({
              showClose: true,
              message: json.data.data,
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          loading.close();
        });
    },
    // 判断进入是否有企业
    getEnterprise() {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = _self.$loading({
        lock: false,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.5)",
      });
      let formdata = new FormData();
      formdata.append("enterpriseName", _self.ruleForm.priseName);
      ajax({
        method: "post",
        url: SOWINURL + "index/getEnterprise",
        data: formdata,
      })
        .then(function (json) {
          loading.close();
          if (json.data.result == 200) {
            _self.uniscid = json.data.data;
            setTimeout(() => {
              _self.getAdd();
            }, 300);
          } else if (json.data.result == 404) {
            _self.$message({
              showClose: true,
              message: json.data.data,
              type: "error",
            });
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          loading.close();
        });
    },
    // 点击支付
    hanglePayment() {
      this.$router.push({
        path: "/dzf",
        query: {
          id: this.busValue,
          lxid: this.active,
        },
      });
    },
    // 点击切换企业
    hangleChange() {
      let qyId = this.busValue;
      let qyList = this.priseList;
      let curQyArr = qyList.filter((item) => item.qyId == qyId);
      let curQyobj = curQyArr[0] || [];
      this.qyMc = (curQyobj && curQyobj.qyMc) || "";

      this.isSet = true;

      this.setUserQy();
      this.$store.state.qyValue = qyId;
    },
    //设置当前操作企业
    setUserQy() {
      let _self = this;
      let ajax = _self.$http.create();
      // const loading = this.$loading({
      //   lock: false,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
      ajax({
        method: "post",
        url: SOWINURL + "index/setUserQy",
        data: {
          qyId: _self.busValue,
        },
        headers: {},
      })
        .then(function (json) {
          // loading.close();
          // console.log(json.data);
          if (json.data.result == 1) {
            let list = json.data.data;
            // _self.businessData = list; //获取所有信息
            // _self.qyPxzt = list.qyPxzt; //培训状态
            // _self.qyShzt = list.qyShzt; //审核状态
            // _self.qyZfzt = list.qyZfzt; //支付状态
            //set后把企业id传过去  后端要求的
            let qyId = list.qyId;
            if (_self.isSet) {
              _self.getMore(qyId);
            } else {
              if (_self.token) {
                _self.getUserQy();
              }
            }
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
          }
        })
        .catch(function (error) {
          // loading.close();
          console.log(error);
        });
    },
    //获取用户企业列表
    getUserQy: function (callback) {
      let _self = this;
      let ajax = _self.$http.create();
      // const loading = this.$loading({
      //   lock: false,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      //   // target: document.querySelector('#app')
      // });

      ajax({
        method: "get",
        url: SOWINURL + "index/getUserQy",
        headers: {
          token: _self.token,
        },
      })
        .then(function (json) {
          // loading.close();
          if (json.data.result == 1) {
            let list = json.data.data;
            _self.pxrId = list.pxrId; //培训人id

            //morekclist中当前企业为空企业各种状态重置
            // if (_self.busValue != "") {
            if (list.qyShyy && list.qyShyy.length > 0) {
              _self.qyShyy = list.qyShyy;
            } else {
              _self.qyShyy = [];
            }
            _self.qyPxzt = list.qyPxzt; //培训状态
            _self.qyShzt = list.qyShzt; //审核状态
            // _self.businessData = list;   //获取所有信息

            _self.qyZfzt = list.qyZfzt; //支付状态
            // } else {
            //   _self.qyShyy = [];
            //   _self.qyPxzt = 3; //培训状态
            //   _self.qyShzt = 0; //审核状态
            //   _self.qyZfzt = 0; //支付状态
            // }
            _self.sfQyfr = list.sfQyfr;
            _self.isSet = false;

            callback && callback();
            // 自动化流程判断
            // console.log(_self.isAutoProcess)

            if (_self.isAutoProcess) {
              // 关联完企业判断下一步操作
              _self.btnTrigger();
            }
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
            if (json.data.result == 2) {
              setTimeout(() => {
                //登录失效删除token
                cookie.delete("xyxf_token_qt");
                window.location.href = SOWINURL + "index/login";
              }, 2000);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
          // loading.close();
        });
    },
    // 点击播放查看是否登录 2，判断是否支付
    hangleVideo(kcid) {
      this.kcId = kcid;
      // 1,先要判断是否登录状态
      if (this.token) {
        if (this.priseList && this.priseList.length > 0) {
          //培训进程必须先选择企业才能看视频
          if (this.busValue) {
            //外省企业必须通过审核才能看视频
            if (this.wsqy == 1 && this.qyShzt != 1) {
              this.$message({
                showClose: true,
                message: "当前企业还没有通过审核",
                type: "error",
              });
            } else {
              this.btnTrigger();
            }
          } else {
            this.$message({
              showClose: true,
              message: "请先在培训进程模块中选择企业",
              type: "error",
            });
          }
        } else {
          // 点击视频没有关联企业开启自动流程把当前数据存起来
          let data = {
            qyId: this.busValue,
            lxId: this.active,
            kcId: this.kcId,
          };
          localStorage.setItem("NEXT_DO_OBJ", JSON.stringify(data));
          // 关联企业
          this.gotoRelationQy("open");
        }
      } else {
        this.$message({
          showClose: true,
          message: "请先登录",
          type: "error",
        });
        // this.$emit('hangleLogin',0)
        return;
      }
    },
    // 点击切换培训内容
    hangleSwiper(id) {
      this.active = id;
      this.getMore();
    },
    // 获取切换数据
    getDataList() {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = _self.$loading({
        lock: false,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.5)",
      });
      ajax({
        method: "get",
        url: SOWINURL + "index/lxList",
        data: {},
      })
        .then(function (json) {
          loading.close();
          if (json.data.result == 1) {
            _self.listData = json.data.data;
            if (_self.listData && _self.listData.length > 0) {
              if (!_self.active) {
                _self.active = _self.listData[0].lxId;
              }
              if (!_self.kcId) {
                _self.kcId = _self.listData[0].kcId;
              }
              _self.getMore();
            }
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          loading.close();
        });
    },
    // 下载
    hangleDow() {
      if (this.materialUrl) {
        window.open(this.materialUrl);
      } else {
        this.$message({
          showClose: true,
          message: "暂无电子版材料",
          type: "error",
        });
      }
    },
    // 点击查看更多
    getMore(qyId) {
      let _self = this;
      let data = {
        lxId: this.active,
      };
      if (qyId) {
        data.qyId = qyId;
      }
      let ajax = _self.$http.create();
      // const loading = _self.$loading({
      //   lock: false,
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(255, 255, 255, 0.5)'
      // });
      ajax({
        method: "get",
        url: SOWINURL + "index/moreKcList",
        params: data,
      })
        .then(function (json) {
          // loading.close();
          if (json.data.result == 1) {
            let list = json.data.data;
            if (list) {
              _self.titleName = list.lxName; //类型名称
              _self.videoList = list.unCompleted; //未完成课程
              _self.materialUrl = list.materialUrl; //zip文件

              // _self.videoList.splice(0,2)
              _self.completed = list.completed; //已完成课程
              _self.totalPxTime = list.totalPxTime; //课程培训的总时长
              _self.userPxTime = list.userPxTime ? list.userPxTime : 0; //用户已培训时长
              _self.totalCompted = list.totalPxTime * 60; //用来做判断把分钟转成秒
              _self.examination = list.examination; //5为补考

              // 判断显示内容
              _self.lxKsgn = list.lxKsgn; //是否显示考试内容
              _self.lxCjbg = list.lxCjbg; //是否显示报告

              let qyList = list.qyList || []; //名下的企业
              _self.priseList = qyList;

              _self.isHistoricalRecord = list.isHistoricalRecord || 0;

              let curQyId = (list.currQy && list.currQy.qyId) || "";
              // if (curQyId) {
              _self.busValue = curQyId;
              _self.$store.state.qyValue = curQyId;

              let curQyArr = qyList.filter((item) => item.qyId == curQyId);
              let curQyobj = curQyArr[0] || [];
              _self.qyMc = (curQyobj && curQyobj.qyMc) || "";
              _self.wsqy = (list.currQy && list.currQy.wsqy) || 0;

              if (_self.token) {
                if (!_self.isSet && curQyId != "") {
                  _self.setUserQy();
                } else {
                  _self.getUserQy();
                }
              }

              // }
            }
            _self.list = list;
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          // loading.close();
        });
    },
    // 查看历史记录
    hangleSee() {
      this.dialogVisible = true;
      this.hangleRecord();
    },
    // 当前数量
    handleSizeChange(val) {
      this.pageLimit = val;
      this.current = 1;
      this.current = 1;
    },
    // 当前页数
    handleCurrentChange(val) {
      this.current = val;
    },
  },
  components: {
    swiper,
    indexHeader,
    smrz,
  },
};
</script>

<style scoped lang="less">
.warp_room {
  width: 100%;
  // margin-bottom: 10px;

  .swiper_warp {
    display: flex;
    align-items: center;
    width: 1210px;
    margin: 0 auto;
    padding-bottom: 110px;
    padding-top: 98px;
    cursor: pointer;

    .swiper_item {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .item_img {
        width: 120px;
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(233, 239, 246);
        border-radius: 50%;

        img {
          width: 50px;
          // height: 50px;
          // object-fit: cover;
        }
      }

      .activeTwo {
        border: 1px solid #0076ff;
        background-color: transparent;
      }

      .item_text {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        margin-top: 10px;
      }
    }

    .line_one_warp {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;

      .swiper_item {
        width: 200px;
        height: 240px;
      }

      .active {
        box-shadow: 0px 0px 15px 0px rgba(180, 211, 246, 0.3);
        border-radius: 10px;
        background-color: #fff;
      }
    }

    // 多个培训
    .item_center {
      display: flex;
      flex-wrap: wrap;
      margin-left: -58px;

      .item_many {
        flex: 25%;
        height: 72px;
        display: flex;
        align-items: center;
        padding-left: 58px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .many_img {
          margin-left: -20px;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: rgba(0, 118, 255, 0.1);

          img {
            width: 20px;
            // height: 20px;
            // object-fit: cover;
          }
        }

        .many_text {
          margin-left: 10px;
        }
      }

      .item_none {
        height: 0;
        width: 25%;
      }
    }

    // .item_many:nth-child(n+2){
    //   margin-left: 58px;
    // }
    .activeMany {
      background-color: #fff;
      border-radius: 10px;

      .many_img {
        background: #fff !important;
        border: 1px #0076ff solid;
        box-sizing: border-box;
      }
    }
  }

  .room_item {
    // padding-bottom: 500px;
    width: 100%;
    background-color: #fff;

    .item_center {
      width: 1210px;
      margin: 0 auto;

      .item_room {
        .item_title {
          font-size: 40px;
          color: #2f2f4f;
          font-weight: 400;
          text-align: center;
          padding-top: 57px;
          padding-bottom: 34px;
          box-sizing: border-box;
        }

        .item_name {
          display: flex;

          .name_left {
            flex: 1;
            font-size: 20px;
            font-weight: bold;
            color: #06103b;
            padding-bottom: 30px;
          }

          .name_right {
            font-size: 16px;
            font-weight: 500;
            text-decoration: underline;
            color: #0076ff;
            cursor: pointer;
          }
        }

        // 未完成
        .item_sub_item {
          display: flex;
          flex-wrap: wrap;
          margin-left: -10px;

          .item_sub {
            flex: 33.33%;
            cursor: pointer;
            padding-left: 10px;
            box-sizing: border-box;
            margin-bottom: 40px;

            .center_vider {
              position: relative;
              // width: 393px;
              height: 240px;

              img {
                width: 100%;
                height: 100%;
              }

              .item_abs {
                position: absolute;
                bottom: 20px;
                right: 20px;
                width: 70px;
                height: 30px;
                border-radius: 15px;
                background: #060e17;
                opacity: 0.5;
                text-align: center;
                line-height: 30px;
                color: #fff;
              }
              .item_icon {
                position: absolute;
                top: 0px;
                right: 0px;
                width: 78px;
                height: 76px;
                img {
                  width: 78px;
                  height: 76px;
                }
              }
            }

            .center_text {
              height: 40px;
              padding: 10px;
              background-color: #f8f8f8;

              .text_left {
                font-size: 18px;
                font-weight: 500;
              }

              .text_right {
                text-align: right;
                font-size: 14px;
                font-weight: 500;
                color: #969697;
              }
            }
          }

          .item_none {
            height: 0;
            width: 33.33%;
          }
        }
      }
    }

    .item_process {
      box-sizing: border-box;
      height: 280px;
      background: url(/static/images/banner3.png) no-repeat;
      background-color: #0077ff;

      .process_item {
        width: 1210px;
        margin: 0 auto;

        /deep/.el-input__inner {
          background-color: transparent;
          color: #fff;
        }

        /deep/.el-select > .el-input {
          width: 400px;
        }

        .item_show {
          display: flex;
          flex-direction: row;
          height: 280px;

          .show_left {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .show_imput {
              // padding-top: 40px;
              box-sizing: border-box;

              .select_qy {
                .select_qy_prefix {
                  display: block;
                  width: 100px;
                }

                /deep/.el-input .el-input__inner {
                  padding-left: 100px;
                }

                & /deep/ .el-input__prefix {
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  margin-top: -2px;
                }
              }
            }

            .name_icon {
              padding-top: 30px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              .title {
                display: flex;
                flex-direction: row;
                align-items: center;
                & img {
                  width: 20px;
                  height: 20px;
                }
                .name_name {
                  font-size: 20px;
                  color: #ffffff;
                  padding-left: 11px;
                  box-sizing: border-box;
                }
              }
              .content {
                margin-top: 20px;
                .name_title {
                  font-size: 16px;
                  color: #fff;
                  box-sizing: border-box;
                }
              }
            }

            .name_report {
              display: flex;
              padding-top: 20px;
              box-sizing: border-box;

              .report_left {
                display: flex;
                align-items: center;

                .left_icon {
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  background-color: #e4e399;
                }

                .left_bg {
                  padding-left: 18px;
                  font-size: 18px;
                  color: #e4e399;
                  box-sizing: border-box;
                }

                .left_xq {
                  color: #fff;
                  font-size: 14px;
                }
              }

              .report_right {
                display: flex;
                align-items: center;
                padding-left: 100px;
                box-sizing: border-box;
                .left_icon {
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  background-color: #e4e399;
                }

                .left_bg {
                  padding-left: 18px;
                  box-sizing: border-box;
                  font-size: 18px;
                  color: #e4e399;
                  cursor: pointer;
                }

                .left_xq {
                  color: #fff;
                  font-size: 14px;
                }
              }
            }

            .history {
              margin-top: 30px;
              cursor: pointer;
              width: 130px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              color: #fff;
              background-color: #6a7ee5;
              border-radius: 4px;
              font-size: 14px;
            }
          }

          .show_right {
            display: flex;
            flex-direction: column;
            justify-content: center;
            .item_popo {
              margin-top: 52px;
            }

            .item_button {
              padding: 20px;
              color: #f4f6fe;
              font-size: 18px;
              cursor: pointer;
              border-radius: 6px;
              border: 1px #fff solid;
              // margin-top: 60px;
              // width: 200px;
              // height: 60px;
              // line-height: 60px;
              // text-align: center;
              // background-color: #fff;
              // color: #3349e3;
            }
          }
        }
      }
    }

    .item_process {
      // margin-top: 20px;
      // margin-bottom: 20px;
      // height: 280px;
      background-size: 100%;
      background: url(/static/images/banner3.png) no-repeat;
      background-color: #0077ff;

      .process_item {
        width: 1210px;
        margin: 0 auto;

        .process_sub {
          // display: flex;
          .sub_left {
            display: flex;
            align-items: center;

            .left {
              flex: 1;
              display: flex;
              align-items: center;
              margin-top: 40px;

              img {
                width: 40px;
                height: 40px;
              }

              & div {
                margin-left: 15px;
                font-size: 30px;
                font-weight: bold;
                color: #ced3f7;
              }
            }
          }

          .sub_right {
            display: flex;
            align-items: center;
            margin-top: 30px;

            .text {
              flex: 1;
              font-weight: bold;
              font-size: 20px;
              color: #f4f6fe;
            }

            .right_text {
              cursor: pointer;
              width: 240px;
              height: 60px;
              line-height: 60px;
              text-align: center;
              font-size: 18px;
              font-weight: bold;
              color: #f4f6fe;
              border: 1px solid rgba(255, 255, 255, 1);
            }
          }

          .sub_buttom {
            display: flex;
            margin-top: 10px;

            .buttom_right {
              color: #fff;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .record_warp {
    .warp {
      padding-bottom: 15px;
      border-bottom: 1px solid #e6e6e6;

      .warp_top {
        display: flex;
        margin-top: 10px;

        // align-items:center;
        .warp_icon {
          width: 22px;
          height: 22px;
          background-color: #ceab74;
          border-radius: 4px;
          font-size: 16px;
          text-align: center;
          line-height: 22px;
          color: #fff;
        }

        .warp_name {
          font-size: 16px;
          flex: 1;
          margin-left: 10px;
        }

        .warp_title {
          font-size: 14px;
          color: #ceab74;
        }
      }

      .exam_time {
        display: flex;
        margin-top: 20px;
        margin-left: 30px;

        .time {
          flex: 1;
        }
      }
    }
  }
}

.prise_center {
  display: flex;
  margin: 50px 30px;
  color: #0076ff;
}

.prise_left {
  flex: 1;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown-link {
  cursor: pointer;
  color: red;
  font-size: 16px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}

/deep/ .el-select-dropdown {
  position: absolute !important;
  top: 50px !important;
  left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index_pxkc.vue